"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useValueForm = exports.createValueForm = void 0;
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const schema_1 = require("./schema");
const setPathValue_1 = require("./setPathValue");
const valueConfig_1 = require("./valueConfig");
const valueFieldProps_1 = require("./valueFieldProps");
const valuePath_1 = require("./valuePath");
const valueStore_1 = require("./valueStore");
const createValueForm = (args) => {
    const { formatMessage, store, value, onChange, validationEffects } = args;
    const config = (0, valueConfig_1.mergeRecursiveValueConfig)(args.config, value);
    return {
        field: (path) => {
            const pathState = (0, valueStore_1.getStoreState)(store, path);
            const pathValue = (0, valuePath_1.getPathValue)(value, path);
            const pathConfig = (0, valueConfig_1.getPathValueConfig)(config, path);
            return (0, valueFieldProps_1.createValueFieldProps)({
                value: pathValue,
                config: pathConfig,
                state: pathState,
                updateValue: (newPathValue) => {
                    var _a;
                    const newValue = (0, setPathValue_1.setPathValue)(value, config, path, newPathValue);
                    const newConfig = (0, valueConfig_1.mergeRecursiveValueConfig)(args.config, newValue);
                    const schema = (0, schema_1.createSchema)(formatMessage, newConfig);
                    const result = schema.safeParse(newValue);
                    const issues = result.success ? [] : result.error.issues;
                    const validationEffect = validationEffects === null || validationEffects === void 0 ? void 0 : validationEffects.find(x => (0, valuePath_1.checkSubPath)(x.target, path));
                    const dependent = validationEffect === null || validationEffect === void 0 ? void 0 : validationEffect.dependent.filter(x => (0, valuePath_1.getPathValue)(newValue, x) !== undefined);
                    (0, valueStore_1.resetStorePath)(store, path, false);
                    (0, valueStore_1.setStoreValueErrors)(store, path, issues, config, dependent);
                    (0, valueStore_1.recoverStoreNestedPath)(store, path, newValue);
                    onChange === null || onChange === void 0 ? void 0 : onChange(newValue, path);
                    if (!(pathConfig === null || pathConfig === void 0 ? void 0 : pathConfig.keepQueryOnValue)) {
                        (_a = pathConfig === null || pathConfig === void 0 ? void 0 : pathConfig.setQuery) === null || _a === void 0 ? void 0 : _a.call(pathConfig, '');
                    }
                },
                formatMessage,
                name: (0, valuePath_1.stringifyPath)(path),
            });
        },
        validateAll: () => {
            const schema = (0, schema_1.createSchema)(formatMessage, config);
            const result = schema.safeParse(value);
            const issues = result.success ? [] : result.error.issues;
            if (!result.success) {
                const requiredValue = (0, setPathValue_1.createRequiredContainers)(value, config);
                const requiredResult = schema.safeParse(requiredValue);
                const requiredIssues = requiredResult.success ? [] : requiredResult.error.issues;
                // Add full details value problems if required exists
                issues.push(...requiredIssues);
            }
            (0, valueStore_1.setStoreValueErrors)(store, [], issues, config);
            const isError = (0, valueStore_1.hasStoreError)(store);
            return !isError;
        },
        isContainsError: (0, valueStore_1.hasStoreError)(store),
    };
};
exports.createValueForm = createValueForm;
const useValueForm = (args) => {
    const { value, config, onChange, validationEffects, hash } = args;
    const { formatMessage } = (0, react_intl_1.useIntl)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const store = (0, react_1.useMemo)(() => [], [hash]);
    const [, rerender] = (0, react_1.useState)({});
    const valueFrom = (0, exports.createValueForm)({
        store,
        formatMessage,
        value,
        config,
        onChange,
        validationEffects,
    });
    const { validateAll } = valueFrom;
    valueFrom.validateAll = () => {
        const result = validateAll();
        rerender({});
        return result;
    };
    return valueFrom;
};
exports.useValueForm = useValueForm;
//# sourceMappingURL=form.js.map